import { GetStaticProps, NextPage } from 'next'
import { BlogHeader } from 'src/components/BlogHeader/BlogHeader'
import { ContentList } from 'src/components/ContentList/ContentList'
import { Footer } from 'src/components/Footer/Footer'
import { Breadcrumb } from 'src/components/global/Breadcrumb'
import MainContainer from 'src/components/global/MainContainer/MainContainer'
import { ThemeOnly } from 'src/components/global/ThemeOnly'
import { THEME } from 'src/config/config'
import { IContentListItemFragment } from 'src/graphql/generated/hooks'
import { Meta } from 'src/layout/Meta'
import { Main } from 'src/templates/Main'
import { getAllIndustryAnalysis } from 'src/utils/getAllIndustryAnalysis'

type Props = {
  articles: IContentListItemFragment[]
}

const IndustryAnalyses: NextPage<Props> = ({ articles }: Props) => {
  const title = 'Industry Analysis'
  const description =
    'Legaltech Hub is founded by a team of legal technology enthusiasts who in their career have acted as buyers, vendors, investors and advisors to buyers and vendors. With more than 50 years of collective experience in legaltech, the team is well placed to help bring transparency to the Legal Tech Market.\
  By listing all relevant legal tech solutions, Legal Tech Hub allows buyers of legal tech to see the woods from the trees, vendors to showcase their solutions and investors to understand the market. Industry insights complement the directory.'

  const meta = <Meta title={title} description={description} url="/industry-analysis/" />

  return (
    <Main meta={meta}>
      <MainContainer id="mainContainer">
        <div className="flex flex-col bg-clouds">
          <Breadcrumb subject="INDUSTRY ANALYSIS" />
          <BlogHeader />
        </div>
        <hr />
        <div className="mb-auto">
          <div className="w-full items-center justify-between md:mb-0 mb-[3rem]">
            <div className="flex flex-col pl-[1.25rem] pr-[1.25rem] !max-w-[1100px] w-full py-2 m-auto">
              <div className="pt-[0.1rem] pb-[0.125rem] text-[24px] font-bold font-secondary text-[#222222] mt-[50px]">
                {<ContentList items={articles} />}
              </div>
            </div>
          </div>
        </div>

        <ThemeOnly theme="legaltech">
          <Footer />
        </ThemeOnly>
      </MainContainer>
    </Main>
  )
}

export default IndustryAnalyses

export const getStaticProps: GetStaticProps<any> = async ({}) => {
  if (THEME === 'ilta')
    return {
      revalidate: 60,
      notFound: true,
    }
  try {
    const articles = await getAllIndustryAnalysis()

    return {
      props: {
        articles: articles.filter((article) => !!article),
      },
      revalidate: 60,
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error occurred in getStaticProps of Industry-Analysis:', error)
    // Graceful fallback in case of an upstream error
    return {
      notFound: true,
      revalidate: 5, // Reattempt fetching during the next static regeneration
    }
  }
}
